import { Routes, Route } from "react-router-dom";

import Header from "./components/Header";
import MobileCallBar from "./components/MobileCallBar";
import Hero from "./components/Hero";
import TrustBar from "./components/sections/TrustBar";
import Services from "./components/Services";
import WhyUs from "./components/sections/WhyUs";
import Process from "./components/sections/Process";
import ScheduleBannerCallOnly from "./components/ScheduleBannerCallOnly";
import Testimonials from "./components/sections/Testimonials";
import ServiceAreas from "./components/sections/ServiceAreas";
import FAQ from "./components/sections/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

/**
 * Homepage section order.
 *
 * Reasoning, in the order a worried homeowner actually moves:
 *   hero          - who we are, the number to call
 *   trust bar     - immediate reassurance before they scroll away
 *   services      - what we do, with "call us if you notice" symptoms
 *   why us        - reasons to pick us over the next listing
 *   process       - removes the fear of an unknown bill
 *   CTA band      - the phone number again, halfway down
 *   testimonials  - social proof (renders nothing until real reviews exist)
 *   service areas - do they even come to my house
 *   FAQ           - last objections
 *   contact       - the fallback path for non-urgent requests
 */
function HomePage() {
  return (
    <>
      <Hero />
      <TrustBar />
      <Services />
      <WhyUs />
      <Process />
      <ScheduleBannerCallOnly />
      <Testimonials />
      <ServiceAreas />
      <FAQ />
      <Contact />
    </>
  );
}

function App() {
  return (
    <div className="flex min-h-screen flex-col bg-surface font-body text-ink">
      <Header />
      {/* Target of the header's skip link. */}
      <main id="main" className="flex-grow">
        <Routes>
          <Route path="/" element={<HomePage />} />
          {/* Per-service routes are intentionally absent. Nothing links to
              them, so there are no dead links. Add ServicePage back here
              once the individual service pages are written. */}
        </Routes>
      </main>
      <Footer />
      {/* Sticky click-to-call bar, mobile only. Rendered last so it stacks
          above page content. Footer carries bottom padding to clear it. */}
      <MobileCallBar />
    </div>
  );
}

export default App;
